// extracted by mini-css-extract-plugin
module.exports = {"item":"Item4_item__1fJe9","active":"Item4_active__pTtyj","head":"Item4_head__3P44Z","body":"Item4_body__2NJyP","button":"Item4_button__3rhx4"};